<div class="gestione-container">
  <h2 class="pink-container" mat-dialog-title>Gestione campi excell</h2>
  <p class="texted" ><b>Deselezionare i campi che non si vogliono visualizzare nel report excell</b></p>
  <mat-dialog-content class="mat-typography">



    <mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="nomeCampo">
        <mat-header-cell *matHeaderCellDef> Denominazione Campo </mat-header-cell>
        <mat-cell [attr.data-label]="'Denominazione Campo'" *matCellDef="let element">
           {{element.descrizioneCampo}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="templateAppartenenza">
        <mat-header-cell *matHeaderCellDef> Nome template/Tipologia </mat-header-cell>
        <mat-cell [attr.data-label]="'Nome template - tipologia template'" *matCellDef="let element">
           {{getNomeAndTPTemplate(element)}}
          </mat-cell>
      </ng-container>

      <ng-container matColumnDef="visualizzabileNelReport">
        <mat-header-cell  *matHeaderCellDef>
          <mat-checkbox class="example-margin" [checked]="true" (change)="setAll($event.checked)"></mat-checkbox>
          Visualizzabile nel report
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-checkbox class="example-margin" [(ngModel)]="element.visualizzabileNelReport"></mat-checkbox>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>

    <mat-paginator style="flex-wrap: wrap;" id='paginator' [pageSize]="5" [pageSizeOptions]="[5, 10, 50, 100]">
    </mat-paginator>

  </mat-dialog-content>

  <mat-dialog-actions align="end">

    <button mat-stroked-button color='accent' class='persBtn' [mat-dialog-close]="false">
      <p class='cont'>Annulla</p>
    </button>
    <button mat-raised-button color='accent' class='persBtn' (click)="confirmAndSendList()" cdkFocusInitial>
      <p class='cont'>Conferma</p>
    </button>

  </mat-dialog-actions>
</div>


